module.exports = __webpack_public_path__ + "3f16e137/img/note-list-icon.961c1485.svg";